/**
 * Construit l'URL de consultation publique d'un document B2C (ticket, facture ticket, commande, devis).
 * Reprend la logique multi-tenant de SendTicketEmailForm : préfixe l'UUID de la société uniquement
 * si REACT_APP_USE_LICENCE_SERVEUR est actif et que la société courante a un uuid.
 *
 * @param {string} kind - Type de document : 'ticket' | 'ticket_facture' | 'commande' | 'devis'
 * @param {number|string} id - ID du document (id du ticket, de la commande ou du devis)
 * @param {string} token - Token de consultation (celui du ticket lié pour commande/devis)
 * @param {Object} authParam - Contexte d'authentification (IsAuthContext.authParam)
 * @returns {string} URL complète de consultation publique
 */
export const buildPublicDocumentUrl = (kind, id, token, authParam) => {
    const urlCompany = (process.env.REACT_APP_USE_LICENCE_SERVEUR && authParam.company && authParam.company.uuid) ? authParam.company.uuid+'/' : '';
    return process.env.REACT_APP_FREEBIRD_URL_EMAIL+"session/"+kind+"/download/"+urlCompany+id+"/"+token;
}
